module.exports = __webpack_public_path__ + "site/img/slingUpdataErcode.024d077.png";


//////////////////
// WEBPACK FOOTER
// ./site/slingUpdataErcode.png?1
// module id = 125
// module chunks = 1